import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "../components/site/Reveal";

const LEGAL_CONTENT = {
  "/mentions-legales": {
    title: "Mentions légales",
    intro:
      "Conformément à la loi pour la confiance dans l'économie numérique, les utilisateurs du site Rozier Concept trouveront ci-dessous les informations légales relatives à l'éditeur, à l'hébergeur et aux conditions d'utilisation du site.",
    sections: [
      {
        title: "Éditeur du site",
        body:
          "Rozier Concept. Informations légales complètes (raison sociale, SIRET, adresse, directeur de la publication) à communiquer prochainement."
      },
      {
        title: "Hébergeur",
        body:
          "Informations relatives à l'hébergeur du site à communiquer prochainement."
      },
      {
        title: "Propriété intellectuelle",
        body:
          "L'ensemble des contenus présents sur ce site (textes, images, identité visuelle, photographies, vidéos) sont la propriété exclusive de Rozier Concept ou de leurs auteurs respectifs. Toute reproduction, représentation ou diffusion, totale ou partielle, est interdite sans autorisation écrite préalable."
      },
      {
        title: "Crédits",
        body:
          "Site conçu et réalisé par Axeris Labs (axeris-labs.fr)."
      }
    ]
  },
  "/politique-de-confidentialite": {
    title: "Politique de confidentialité",
    intro:
      "Rozier Concept attache une grande importance au respect de votre vie privée. Cette politique précise la manière dont vos données personnelles sont collectées, utilisées et protégées dans le cadre de votre navigation et de vos demandes via ce site.",
    sections: [
      {
        title: "Données collectées",
        body:
          "Les seules données collectées sont celles que vous nous transmettez volontairement via le formulaire de contact : nom, courriel, téléphone et description de votre projet. Aucune donnée sensible n'est demandée."
      },
      {
        title: "Finalité du traitement",
        body:
          "Vos données sont utilisées uniquement pour répondre à votre demande, organiser un échange et assurer le suivi de votre projet. Elles ne font l'objet d'aucune cession ni revente à des tiers."
      },
      {
        title: "Durée de conservation",
        body:
          "Vos données sont conservées le temps strictement nécessaire au traitement de votre demande, puis archivées ou supprimées conformément aux obligations légales."
      },
      {
        title: "Vos droits",
        body:
          "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression, de limitation et de portabilité de vos données. Vous pouvez exercer ces droits en nous adressant un courriel à l'adresse qui sera communiquée prochainement."
      },
      {
        title: "Cookies",
        body:
          "Ce site n'utilise pas de cookies de traçage publicitaire. Seuls les cookies strictement nécessaires au bon fonctionnement du site peuvent être déposés."
      }
    ]
  }
};

export default function Legal() {
  const { pathname } = useLocation();
  const content = LEGAL_CONTENT[pathname];

  if (!content) {
    return (
      <div className="pt-[140px] pb-24 container-rozier">
        <p className="font-serif text-3xl text-charcoal">Page introuvable.</p>
      </div>
    );
  }

  return (
    <div data-testid="page-legal">
      <section className="pt-[120px] md:pt-[140px] pb-16 bg-ivory border-b border-stone">
        <div className="container-rozier">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-graphite hover:text-gold transition-colors text-xs uppercase tracking-[0.28em] mb-6"
            data-testid="legal-back-home"
          >
            <ArrowLeft size={14} />
            Accueil
          </Link>
          <Reveal>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-charcoal leading-[1.05] tracking-tight font-light">
              {content.title}
            </h1>
          </Reveal>
          <Reveal delay={150}>
            <p className="mt-8 text-graphite text-base md:text-lg leading-[1.85] max-w-3xl">
              {content.intro}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 md:py-24 bg-white">
        <div className="container-rozier max-w-3xl">
          {content.sections.map((s, i) => (
            <Reveal key={s.title} delay={i * 80}>
              <div className="border-l-2 border-gold pl-6 mb-12">
                <p className="overline text-charcoal mb-3">{s.title}</p>
                <p className="text-graphite text-base md:text-[17px] leading-[1.9]">
                  {s.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
